import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { toast } from 'sonner';

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { exchangeSession } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/login', { replace: true });
      return;
    }

    // Clear hash immediately
    window.history.replaceState(null, '', window.location.pathname);

    const processAuth = async () => {
      try {
        const data = await exchangeSession(sessionId);
        toast.success(`Welcome, ${data.user?.name || 'Admin'}!`);
        navigate('/admin/dashboard', { replace: true, state: { user: data.user } });
      } catch (err) {
        toast.error(err.message || 'Authentication failed');
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-teal-50">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-green-600 border-r-transparent mb-4" />
        <p className="text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};
